import t from "@/lang/lang";
import {
  InvoicesPageMain,
  InvoicesPageMainContent,
  InvoicesPageMainHeader,
} from "@/routes/invoices/_components/invoices-page";
import { OutboxGesecInvoiceDeleteDialog } from "@/services/backend/business-central/components/outbox-gesec-invoice-delete-dialog";
import { OutboxGesecInvoicePage } from "@/services/backend/business-central/components/outbox-gesec-invoice-page";
import { OutboxGesecInvoiceSendDialog } from "@/services/backend/business-central/components/outbox-gesec-invoice-send-dialog";
import { useBusinessCentralOutboxGesecInvoicesShowQuery } from "@/services/backend/business-central/api/outbox-gesec-invoice-api";
import { OutboxStatus } from "@/services/backend/business-central/types/outbox";
import { CpyDialog } from "@/services/backend/cpy/components/cpy-dialog";
import { CpyName } from "@/services/backend/cpy/types/entity-names";
import { Button } from "@/shared/components/ui/button";
import { PersistenceStateUsingContext } from "@/shared/lib/persistence-state/persistence-state-info";
import { PersistenceContextProvider } from "@/shared/lib/persistence-state/provider";
import { Copy } from "lucide-react";
import { useNavigate, useParams } from "react-router";

export function OutboxGesecInvoiceRoute() {
  const { outboxId } = useParams();
  const navigate = useNavigate();
  const onDeleteSuccess = () => {
    navigate("/invoices/business-central/outbox/gesec-invoices");
  };
  const { data } = useBusinessCentralOutboxGesecInvoicesShowQuery({
    outboxId: outboxId!,
  });

  return (
    <PersistenceContextProvider>
      <InvoicesPageMain>
        <InvoicesPageMainHeader
          breadcrumbs={[
            {
              label: "Rechnungsstellung",
              to: "/invoices",
            },
            {
              label: "Business Central",
              to: "/invoices/business-central/outbox",
            },
            {
              label: "Gesec Rechnungen",
              to: "/invoices/business-central/outbox/gesec-invoices",
            },
          ]}
          onNavigateTo={navigate}
        >
          <div className="ml-auto flex gap-2">
            <PersistenceStateUsingContext />
            <OutboxGesecInvoiceDeleteDialog
              outboxId={outboxId!}
              onSuccess={onDeleteSuccess}
            />
            <CpyDialog
              destinationEntityName={CpyName.BCOutboxGesecInvoice}
              destinationId={outboxId!}
              trigger={
                <Button variant="outline" size="sm">
                  <Copy className="h-4 w-4" />
                  <span>{t("Daten kopieren")}</span>
                </Button>
              }
              disabled={data && data.outboxStatus === OutboxStatus.Sent}
            />
            <OutboxGesecInvoiceSendDialog outboxId={outboxId!} />
          </div>
        </InvoicesPageMainHeader>
        <InvoicesPageMainContent>
          <OutboxGesecInvoicePage outboxId={outboxId!} />
        </InvoicesPageMainContent>
      </InvoicesPageMain>
    </PersistenceContextProvider>
  );
}
